<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/NeutralAppIcon.svg" class="h-20px w-20px mr-2" /> {{'MostNeutralApps' | localize}}
        </h5>

    </div>

    <div class="card-body p-3">


        <!--Shimmer Code-->

        <div *ngIf="!isLoaded &&  isNeutralAppsEmpty" class="pt-2">
            <div class="col-md-12">
                <div class="card  h-55px  mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>

            <div class="col-md-12">
                <div class="card  mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>

            <div class="col-md-12">
                <div class="card mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>

            <div class="col-md-12">
                <div class="card mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>

        </div>

        <!--Empty State UI Code-->
        <div *ngIf="isLoaded &&  isNeutralAppsEmpty">

            <div>
                <div class="d-flex justify-content-center">
                    <div class="d-flex flex-column mt-10">
                        <img src="../../../../assets/common/images/new-dashboard/neutral-empty-ui.png" class="w-150px h-200px ml-6" />
                        <h6 class="text-muted mt-4 ml-8">{{'NoDataFounds'| localize}}</h6>
                    </div>
                </div>
            </div>
        </div>


        <!--Neutrals Apps UI Code-->
        <div *ngIf="isLoaded &&  !isNeutralAppsEmpty" style="overflow: auto; overflow-x: hidden;">
            <div *ngFor=" let neutral of NeutralAppsDetails | slice: 0:5; index as i" class="px-3 pt-3 row">
                <div *ngIf="i < 5 || true" class="col-md-12" (onHidden)="removeData()" containerClass="popTemplateClass"
                     (onShown)="GetData(neutral.applicationName)" data-toggle="popover" container="body" placement="bottom"
                     data-trigger="hover" data-html="true" [popover]="popTemplate2"
                     triggers="mouseenter:mouseleave">
                    <div class="card borderclassNeutral cardbackgroundNeutral h-55px border mb-2 borderclass">
                        <div class="px-5 align-item-center row">
                            <div class="col-md-2 mt-2">
                                <!-- <img [src]="" class="img-fluid" /> -->
                                <img *ngIf="!LoadingStarted || neutral.applicationName!=HistoryForApp" src="{{neutral.icon ? neutral.icon : 'assets/common/images/timetracking/produactivity/inDesign.png'}}"  id="myElement"/>
                                <img *ngIf="LoadingStarted && neutral.applicationName==HistoryForApp" src='assets/common/images/loading.gif' id="myElement" />

                            </div>

                            <div class="col-md-7 mt-2">
                                <div class=" row mt-3">
                                    <span pTooltip="{{ neutral.applicationName }}" [tooltipDisabled]="_tus.showTooltipForString(neutral.applicationName, 25)" tooltipPosition="bottom">{{neutral.applicationName | slice:0:25}} {{neutral.applicationName.length > 25 ? '...' : ''}}</span>
                                    <!-- {{neutral.applicationName}} -->
                                </div>
                                <!-- <div class=" row text-muted font-12">
                                    -
                                </div> -->


                            </div>

                            <div class="col-md-3 mt-4">
                                <div class="text-center">
                                    <!-- <span *ngIf="neutral.applicationSpendTime">  {{stringToDate(neutral.applicationSpendTime)}}</span> -->
                                    <span *ngIf="neutral.applicationSpendTime">  {{neutral.applicationSpendTime | timerToHrsMinsSec}}</span>
                                    <span *ngIf="neutral.applicationSpendTime == null">00:00 {{'h' | localize}}</span>

                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <ng-template #popTemplate2>
                    <div *ngIf="ShowDetails">
                        <div *ngFor="let app of HistoryDetails">
                            <div class="row min-w-120px">
                                <div class="col-md-10">
                                    <div class="h6">
                                         <span>{{app.windowName}}</span>
                                    </div>
                                </div>
                                <div class="col-md-2 d-flex px-2">
                                    <small *ngIf="app.hours!=0">
                                        {{app.hours}}{{'h' | localize}}
                                    </small>
                                    <small *ngIf="app.minutes!=0">
                                        {{app.minutes}}{{'m' | localize}}
                                    </small>
                                    <small *ngIf="app.hours==0 && app.minutes==0">
                                        {{app.seconds}}{{'s' | localize}}
                                    </small>
                                </div>
                            </div>
                        </div>

                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
